import { useEffect } from "react";

import { restoreDroppedPush } from "../../lib/push";
import { useSession } from "../../session";

/**
 * Puts back notifications that asset recovery dropped on this device
 * (issue #569). Renders nothing. Recovery only runs when the app could not
 * start, so the owner never turned them off; they should come back without
 * being asked.
 */
export function RestoreDroppedPush() {
  const { profileId } = useSession();

  useEffect(() => {
    if (!profileId) return;
    // A failure leaves the note in place and is tried again at the next start.
    restoreDroppedPush(profileId).catch(() => {});
  }, [profileId]);

  return null;
}
